module.exports = __webpack_public_path__ + "img/banner07m.2aa94872.png";